import { render } from "./VButton.vue?vue&type=template&id=69248412"
import script from "./VButton.vue?vue&type=script&lang=ts"
export * from "./VButton.vue?vue&type=script&lang=ts"

import "./VButton.vue?vue&type=style&index=0&id=69248412&lang=stylus"
script.render = render

export default script